/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UnitsDeleteModalMutationVariables = {|
  id: string
|};
export type UnitsDeleteModalMutationResponse = {|
  +unitMeasureDelete: ?{|
    +deleted: ?boolean
  |}
|};
export type UnitsDeleteModalMutation = {|
  variables: UnitsDeleteModalMutationVariables,
  response: UnitsDeleteModalMutationResponse,
|};
*/


/*
mutation UnitsDeleteModalMutation(
  $id: ID!
) {
  unitMeasureDelete(input: {id: $id}) {
    deleted
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "UnitMeasureDeletePayload",
    "kind": "LinkedField",
    "name": "unitMeasureDelete",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deleted",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UnitsDeleteModalMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UnitsDeleteModalMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "UnitsDeleteModalMutation",
    "operationKind": "mutation",
    "text": "mutation UnitsDeleteModalMutation(\n  $id: ID!\n) {\n  unitMeasureDelete(input: {id: $id}) {\n    deleted\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a85c384e5d6f2cdbac290c3c3340cdf9';

module.exports = node;
